import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ButtonNav from './ButtonNav';
import { useAlbum } from '../../contexts/AlbumContext';

const Navigation = () => {
  const location = useLocation();
  const { history, loading } = useAlbum();
  const projectId = localStorage.getItem('albumGeneratorUser');

  return (
    <nav className="flex flex-row flex-wrap sm:justify-between items-center pb-2 sm:pt-2 sm:px-2">
      <Link className="flex flex-row flex-1 justify-center items-center cursor-default" to="/settings">
        <ButtonNav
          icon="tune"
          value="Config"
          isCurrent={location.pathname === '/settings'}
        />
      </Link>
      
      {projectId && (
        <>
          <Link className="flex flex-row flex-1 justify-center items-center cursor-default" to="/today">
            <ButtonNav
              icon={(history?.length || 0) + 1}
              value="Today"
              isCurrent={location.pathname === '/today'}
              isToday={true}
              loading={loading}
            />
          </Link>

          <Link className="flex flex-row flex-1 justify-center items-center cursor-default" to="/history">
            <ButtonNav
              icon="settings_backup_restore"
              value="History"
              isCurrent={location.pathname === '/history'}
            />
          </Link>
        </>
      )}

      <Link className="flex flex-row flex-1 justify-center items-center cursor-default" to="/about">
        <ButtonNav
          icon="info"
          value="About"
          isCurrent={location.pathname === '/about'}
        />
      </Link>
    </nav>
  );
};

export default Navigation;